module.exports = __webpack_public_path__ + "img/afbeelding-evenement.21906ddd.png";